export default theme => ({
  buttonsContainer: {
    marginTop: theme.spacing.unit * 2,
  },
})
